/**
* All rights Reserved, Designed By www.feidai.com
* @Title: marketActivity.ts
* @Package:
* @author: 青瞳科技
* @date: 2026/03/10 09:52:09
* @version: V1.0
* @Copyright: 2019 www.feidai.com Inc. All rights reserved.
* @Belong To: 青瞳科技
* 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
*/
const marketActivityRouter = [
  {
    path: "/marketActivity",
    name: "MarketActivity",
    component: () =>
      import(
        /* webpackChunkName: "marketActivity" */ "@/views/marketActivity/index.vue"
      ),
    meta: {
      title: "营销活动",
      deepth: 2,
      keepAlive: true,
    },
  },
  {
    path: "/selectTemplate",
    name: "SelectTemplate",
    component: () =>
      import(
        /* webpackChunkName: "marketActivity" */ "@/views/marketActivity/selectTemplate/index.vue"
      ),
    meta: {
      title: "选择模版",
      deepth: 3,
    },
  },
  {
    path: "/marketActivityDetail",
    name: "marketActivityDetail",
    component: () =>
      import(
        /* webpackChunkName: "marketActivity" */ "@/views/marketActivity/detail/index.vue"
      ),
    meta: {
      title: "活动详情",
      deepth: 3,
    },
  },
  {
    path: "/createMarketActivity",
    name: "CreateMarketActivity",
    component: () =>
      import(
        /* webpackChunkName: "marketActivity" */ "@/views/marketActivity/create/index.vue"
      ),
    meta: {
      title: "抽奖活动创建",
      deepth: 4,
    },
  },
  {
    path: "/marketActivityConfig",
    name: "marketActivityConfig",
    component: () =>
      import(
        /* webpackChunkName: "marketActivity" */ "@/views/marketActivity/config/index.vue"
      ),
    meta: {
      title: "查看配置",
      deepth: 4,
    },
  },
]

export default marketActivityRouter;